export default __webpack_public_path__ + "static/media/agents.069133d2.svg";